import { useState } from "react";
import {  useNavigate } from "react-router-dom";
import { useOutletContext } from "react-router-dom";

// form validation import 
import { z } from 'zod';




const schema = z.object({
  make: z.string().trim().min(1, "What brand is ypur car?"),
  model: z.string().trim().min(1, "What model is your car?"),
  year: z.string().trim().regex(/^\d{4}$/, "Please be practical"),
  plate: z.string().trim().min(1, "Plate is required"),
  odo: z.coerce.number().min(1, "Is your car still in factory?"),
})

const CarDetails = () => {
  const { bookingData, setBookingData } = useOutletContext();
  const [errors, setErrors] = useState({});
  

  const navigate = useNavigate();

  



  const updateVehicle = (key, value) => {
    setBookingData((prev) => ({
      ...prev,
      vehicle: {
        ...(prev.vehicle || {
          make: "",
          model: "",
          year: "",
          odo: "",
          plate: "",
        }),
        [key]: value,
      },
    }));
  };
  // Here error handling for missing records required -> future ma 
  const vehicle = bookingData.vehicle || {
    make: "",
    model: "",
    year: "",
    odo: "",
    plate: "",
  };


  const validateForm = () => {
    // e.preventDefault();

    const validate = schema.safeParse(vehicle);

    if (!validate.success) {
      const tree = z.treeifyError(validate.error);
      const props = tree?.properties ?? {};
      setErrors({
        make: props.make?.errors?.[0],
        model: props.model?.errors?.[0],
        year: props.year?.errors?.[0],
        plate: props.plate?.errors?.[0],
        odo: props.odo?.errors?.[0],
      });
      
      return false;
    }

    setErrors({})
    return true;
   
  }

  const proceedNext = () => {
    const validateConfirm = validateForm();
    if (validateConfirm) {
      navigate("/appointments/service");
    };

      // navigate("/appointments/service");


  }


  return (
    <section className="rounded-2xl bg-white p-6 shadow-sm">
      <h2 className="text-xl font-semibold">Car Details</h2>

      <div className="mt-6 grid gap-4 sm:grid-cols-3">

        <div>

          <input
            className="input border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Make"
            value={vehicle.make}
            onChange={(e) => updateVehicle("make", e.target.value)}
          />
          {errors.make && <p className="mt-1 text-sm text-red-600">{errors.make}</p>}

        </div>

        <div>

          <input
            className="input border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Model"
            value={vehicle.model}
            onChange={(e) => updateVehicle("model", e.target.value)}
          />
          {errors.model && <p className="mt-1 text-sm text-red-600">{errors.model}</p>}

        </div>
        <div>
          <input
            className="input border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Year"
            value={vehicle.year}
            onChange={(e) => updateVehicle("year", e.target.value)}
          />
          {errors.year && <p className="mt-1 text-sm text-red-600">{errors.year}</p>}

        </div>
        <div>
          <input
            className="input border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Plate Number"
            value={vehicle.plate}
            onChange={(e) => updateVehicle("plate", e.target.value)}
          />
          {errors.plate && <p className="mt-1 text-sm text-red-600">{errors.plate}</p>}

        </div>
        <div>


          <input
            type="number"
            className="input border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            placeholder="ODO meter"
            value={vehicle.odo}
            onChange={(e) => updateVehicle("odo", e.target.value)}
          />
          {errors.odo && <p className="mt-1 text-sm text-red-600">{errors.odo}</p>}

        </div>
      </div>

      <div className="mt-8 flex justify-end">
       <button
  type="button"
  onClick={proceedNext}
  
  className="rounded-xl px-6 py-3 text-sm font-semibold text-white  bg-blue-400 "
>
  Choose Services →
</button>
      </div>
    </section>
  );
};

export default CarDetails;
